import React from "react";

export function Button({
  id,
  type = "button",
  onClick,
  label,
  icon,
  iconPosition = "right",
  disabled = false,
  roundedButton = false,
  isLight = false,
  isBordered = false,
  customClass = "",
  style = {},
  ...props
}) {
  const baseClass = "inline-flex items-center justify-center transition-all text-sm shadow-sm hover:shadow-md active:scale-[0.98] disabled:shadow-none disabled:active:scale-100";
  const shapeClass = roundedButton ? "rounded-full px-6 py-2" : "rounded-md px-4 py-2.5";

  // Determine if background color is passed in style to prevent class conflict
  const hasCustomBg = !!style.backgroundColor;

  const colorClass = disabled
    ? "bg-gray-300 text-white"
    : isLight
      ? "bg-[#118740] text-white"
      : isBordered
        ? "border border-[#138CE3] text-[#138CE3] bg-white font-bold"
        : hasCustomBg
          ? "text-white"
          : "bg-gradient-to-b from-[#1190E4] to-[#3552D8] text-white";

  const finalClass = `${baseClass} ${shapeClass} ${colorClass} ${customClass}`;

  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      className={finalClass}
      style={{ whiteSpace: "nowrap", ...style }}
      disabled={disabled}
      {...props}
    >
      {icon && iconPosition === "left" && (
        <span className="w-4 h-4 mr-2 flex items-center justify-center">{icon}</span>
      )}
      <span>{label}</span>
      {icon && iconPosition === "right" && (
        <span className="w-4 h-4 ml-2 flex items-center justify-center">{icon}</span>
      )}
    </button>
  );
}
